import { useField, useForm } from 'react-final-form'
import { FieldValidator } from 'final-form'
import { Autosuggest, AutosuggestProps } from './Autosuggest'

export type AutosuggestFieldProps<Item> = Omit<AutosuggestProps<Item>, 'value' | 'onChange'> & {
  name: string
  onChange?: AutosuggestProps<Item>['onChange']
  validate?: FieldValidator<Item[]>
}

export function AutosuggestField<Item extends { id: string }>({
  name,
  validate,
  ...props
}: AutosuggestFieldProps<Item>) {
  const form = useForm()
  const { input, meta } = useField<Item[]>(name, { validate })

  const errorMessage = meta.error || meta.submitError || props.error

  return (
    <Autosuggest<Item>
      {...input}
      value={input.value ?? []}
      onChange={(value) => {
        props.onChange?.(value)
        form.change(name, value)
      }}
      {...props}
      error={Boolean(meta.touched && errorMessage)}
      formHelperText={(meta.touched && errorMessage) || undefined}
    />
  )
}
